import { BodyText, Div, Flex, Gutter, Title } from '@gaiads/telia-react-component-library';
import { TeliaTextInput } from '@teliads/components/react';
import { useTranslation } from 'react-i18next';

import styles from './DeviceEnrollment.module.scss';

interface DeviceEnrollmentProps {
  appleEnrollmentId: string | null | undefined;
  setAppleEnrollmentId: (appleEnrollmentId: string) => void;
  samsungEnrollmentId: string | null | undefined;
  setSamsungEnrollmentId: (samsungEnrollmentId: string) => void;
}

export default function DeviceEnrollment(props: DeviceEnrollmentProps) {
  const { appleEnrollmentId, setAppleEnrollmentId, samsungEnrollmentId, setSamsungEnrollmentId } = props;

  const { t } = useTranslation('organizationForm');

  return (
    <Div padding={{ size: 'lg' }} boxShadow="md">
      <Title size={'sm'}>{t('device_enrollment.device_enrollment')}</Title>
      <Flex directionColumn className={styles['customer-organization-form__device_enrollment__device-enrollment-info-inputs-container']}>
        <Gutter size="layout-5" />
        <BodyText size="sm">{t('device_enrollment.device_enrollment_info')}</BodyText>
        <Gutter size="layout-5" />
        <TeliaTextInput
          label={t('device_enrollment.apple_enrollment_input_label')}
          onValueChange={(e: CustomEvent) => setAppleEnrollmentId(e.detail.target.value)}
          value={appleEnrollmentId || ''}
        />
        <Gutter size="layout-5" />
        <TeliaTextInput
          label={t('device_enrollment.samsung_enrollment_input_label')}
          onValueChange={(e: CustomEvent) => setSamsungEnrollmentId(e.detail.target.value)}
          value={samsungEnrollmentId || ''}
        />
      </Flex>
    </Div>
  );
}
